import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useEffect, useMemo, useState } from "react";

import { useGetAllBillingsViaDataLineID } from "../api/getAllBillingsViaDataLineID";

// All your logic is here
export const useDataLineBillingReport = ({dataLineID}: useDataLineBillingReportProps) => {
  const [modalEvent, setModalEvent] = useState<IEvent>({action: "",selectedRows: [],});
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetBillingReportViaDataLineID[]>([]);
  const getAllBillingsViaDataLineNumberQuery = useGetAllBillingsViaDataLineID({dataLineID: dataLineID});
  const { t } = useTranslation();

  const loadingDone = [getAllBillingsViaDataLineNumberQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getAllBillingsViaDataLineNumberQuery].some(({ isError }) => isError);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" },
    { id: 9, apiType: "Number", frontType: "number", frontDisplayFormat: "", defaultEmptyValue: 0 }
  ];

  const data = getAllBillingsViaDataLineNumberQuery.data ? getAllBillingsViaDataLineNumberQuery.data : [];

  const columnData = [
    {
      columnName: "date",
      columnDisplayName: "Ημερομηνία Ελέγχου",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "monthYear",
      columnDisplayName: "Λογαριασμός",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "dateFrom",
      columnDisplayName: "Από",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "dateTo",
      columnDisplayName: "Εώς",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "cost",
      columnDisplayName: "Κόστος",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "lineEnd",
      columnDisplayName: "Άκρο",
      visible: true,
      columnOrder: 6,
      isDraggable: false,
      columnDataType: "String",
    },
  ]

  const columns = useMemo(() => {
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);

  const closeActionModal = () => {
    setModalEvent({ action: "", selectedRows: [] });
  };

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Νέος Έλεγχος");
        break;
      case "edit":
        title = t("Επεξεργασία Έλέγχου");
        break;
      case "delete":
        title = t("Διαγραφή Έλέγχου");
        break; 
      default:
        break;
    }
    return title;
  };

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0]
      ? [...[selectedRowsOfTable[0].id]]
      : [];
    console.log(
      "selectedRows",
      selectedRows,
      "selectedRowOfTable",
      selectedRowsOfTable,
      "selectedRowOfTable[0]",
      selectedRowsOfTable[0]
    );
    setModalEvent({ action: event.action, selectedRows: selectedRows });
  };

  useEffect(() => {
    setSelectedRowsOfTable([]);
   /*  getAllBillingsViaDataLineNumberQuery.refetch(); */
  }, [getAllBillingsViaDataLineNumberQuery.data]); 

  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};

interface useDataLineBillingReportProps {
  dataLineID: number;
}